import { useState, useEffect } from 'react';

function useImage(src: string) {
  const [status, setStatus] = useState({ loaded: false, error: false });
  const [image, setImage] = useState<HTMLImageElement | null>(null);

  useEffect(() => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = src;

    const handleLoad = () => {
      setStatus({ loaded: true, error: false });
    };

    const handleError = () => {
      setStatus({ loaded: false, error: true });
    };

    img.addEventListener('load', handleLoad);
    img.addEventListener('error', handleError);

    setImage(img);

    return () => {
      img.removeEventListener('load', handleLoad);
      img.removeEventListener('error', handleError);
    };
  }, [src]);

  return {
    image,
    isLoaded: status.loaded,
    isError: status.error
  };
}

export default useImage;